export default {"src":"/_next/static/image/src/assets/email/email-foreground-primary.8afee968f85a8f8fab94ccf6f6b655b1.svg","height":24,"width":24};